import { render, staticRenderFns } from "./EditUserNotifications.vue?vue&type=template&id=a2eab7e8&scoped=true&"
import script from "./EditUserNotifications.vue?vue&type=script&lang=js&"
export * from "./EditUserNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EditUserNotifications.vue?vue&type=style&index=0&id=a2eab7e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eab7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2eab7e8')) {
      api.createRecord('a2eab7e8', component.options)
    } else {
      api.reload('a2eab7e8', component.options)
    }
    module.hot.accept("./EditUserNotifications.vue?vue&type=template&id=a2eab7e8&scoped=true&", function () {
      api.rerender('a2eab7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/EditUserNotifications.vue"
export default component.exports